import api, { apiErrorHandler } from "api";
import { ParollConstants } from "constants/constants";
import { customToast } from "hooks/toast";
import moment from "moment";
import { RootState } from "reducers/rootReducer";
import { Dispatch } from "redux";
import { PayrollUserData, PayrollRowData } from "types/Payroll";
import {
  areAllPayrollRowsSelected,
  getPayrollUserDatesFromRows,
  togglePayrollUserDate,
} from "utils/payrollHelpers";

export const getPayrollData =
  (params: { user_id?: number | boolean; year?: number; week?: number }) =>
  (dispatch: Dispatch) => {
    const onError = () => dispatch({ type: ParollConstants.PAYROLL_TABLE_GET_DATA_ERROR });
    dispatch({ type: ParollConstants.PAYROLL_TABLE_GET_DATA_LOADING });
    api
      .getPayrollData(params)
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: ParollConstants.PAYROLL_TABLE_GET_DATA_SUCCESS,
            payload: {
              dataList: res?.data.dataList,
              userList: res?.data.userList,
            },
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const payrollSetFilter =
  (data: {
    search?: string;
    week_date?: string;
    user?: string | PayrollUserData | null | number;
    type?: string;
    month?: string;
    year?: string;
    station?: number;
    userRole?: number;
    userStatus?: number;
    rangeDateOne?: string;
    rangeDateTwo?: string;
    ordering?: string;
  }) =>
  (dispatch: Dispatch, getStore: () => RootState) => {
    const { payrollFilters } = getStore()?.payrollTable;
    dispatch({
      type: ParollConstants.PAYROLL_PAGE_SET_FILTERS,
      payload: { ...payrollFilters, ...data },
    });
  };

export const defaultPayloadTableRangeDates =
  () => async (dispatch: Dispatch, getStore: () => RootState) => {
    const { payrollFilters } = getStore()?.payrollTable;
    dispatch({
      type: ParollConstants.PAYROLL_PAGE_SET_FILTERS,
      payload: {
        ...payrollFilters,
        rangeDateOne: `${moment().format("yyyy")}-W${moment().format("W")}`,
        rangeDateTwo: `${moment().format("yyyy")}-W${moment().format("W")}`,
      },
    });
  };

export const updatePayloadTableRangeDates =
  (startDate: string, endDate: string) => async (dispatch: Dispatch, getStore: () => RootState) => {
    const { payrollFilters } = getStore()?.payrollTable;
    dispatch({
      type: ParollConstants.PAYROLL_PAGE_SET_FILTERS,
      payload: { ...payrollFilters, rangeDateOne: startDate, rangeDateTwo: endDate },
    });
  };

export const payrollUpdateReportRecord =
  (date: string | number | undefined, comment: string, user_id: number, station_id: number) =>
  (dispatch: Dispatch, getStore: () => RootState) => {
    const { dataList } = getStore()?.payrollTable;
    const onError = () => dispatch({ type: ParollConstants.PAYROLL_TABLE_GET_DATA_ERROR });
    dispatch({ type: ParollConstants.PAYROLL_TABLE_GET_DATA_LOADING });
    api
      .createOrUpdatePayrollReport({
        date,
        comment,
        user_id: user_id,
        station: station_id,
      })
      .then((res) => {
        const newList = dataList.map((report) =>
          report.date === date && report.user_id === user_id && report.station_id === station_id
            ? { ...report, comment: comment }
            : report,
        );

        dispatch({
          type: ParollConstants.PAYROLL_TABLE_CREATE_UPDATE_REPORT,
          payload: newList,
        });
      })
      .catch(apiErrorHandler(onError));
  };

export const payrollToggleUserDate =
  (userId: number, date: string) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { selctedUserDatesList } = getStore()?.payrollTable;
    dispatch({
      type: ParollConstants.PAYROLL_TABLE_SET_SELECTED_USER_DATES,
      payload: togglePayrollUserDate(selctedUserDatesList, userId, date),
    });
  };

export const payrollSelectAllUserDates =
  (rows: PayrollRowData[]) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { selctedUserDatesList } = getStore()?.payrollTable;
    dispatch({
      type: ParollConstants.PAYROLL_TABLE_SET_SELECTED_USER_DATES,
      payload: areAllPayrollRowsSelected(selctedUserDatesList, rows)
        ? []
        : getPayrollUserDatesFromRows(rows),
    });
  };

export const sendPayrollSendMessagesAction =
  (isMissed?: boolean) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { selctedUserDatesList } = getStore()?.payrollTable;
    api
      .sendPayrollMessages({
        user_list: JSON.stringify(selctedUserDatesList),
        is_missed: isMissed,
      })
      .then(() => {
        customToast("success", "Message has been send!");
        dispatch({ type: ParollConstants.PAYROLL_TABLE_PAYROLL_SEND_MESSAGES });
      })
      .catch(
        apiErrorHandler(() => {
          customToast("error", "Something was wrong!");
        }),
      );
  };
